/** API / main-card type used by thehope.one Impact Cards. */
export const IMPACT_CARD_TYPE = "Impact_Card";

/** Normalize Single_Card / "impact card" / impact-card → impact_card. */
export function normalizeCardTypeKey(type?: string | null): string {
  return String(type ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function isImpactCardType(type?: string | null): boolean {
  const key = normalizeCardTypeKey(type);
  return (
    key === "impact_card" ||
    key === "impact" ||
    key === "impact_card_template" ||
    key.endsWith("_impact_card")
  );
}

/** Charm / thumbnail rows may only set `template` ("Impact Card Template"). */
export function isImpactCardRecord(card?: {
  type?: string | null;
  template?: string | null;
  main_card?: { type?: string | null; template?: string | null } | null;
} | null): boolean {
  const row = card?.main_card ?? card;
  return isImpactCardType(row?.type) || isImpactCardType(row?.template);
}

/** The talent who created/published the card. Collecting or purchase is never ownership. */
export function isImpactCardCreator(
  cardTalentId?: number | string | null,
  currentTalentId?: number | string | null
): boolean {
  if (cardTalentId == null || currentTalentId == null) return false;
  const cardId = String(cardTalentId).trim();
  const talentId = String(currentTalentId).trim();
  if (!cardId || !talentId) return false;
  return cardId === talentId;
}

export function viewerIsImpactCardCreator(
  cardTalentId?: number | string | null,
  viewer?: {
    talentId?: number | string | null;
    userId?: number | string | null;
    talentIds?: Array<number | string | null | undefined> | null;
  } | null
): boolean {
  if (!viewer) return false;
  const ids = [
    viewer.talentId,
    viewer.userId,
    ...(viewer.talentIds ?? []),
  ];
  return ids.some((id) => isImpactCardCreator(cardTalentId, id));
}

export function readImpactCardCreatorTalentId(source?: {
  talent_id?: number | string | null;
  talent?: { id?: number | string | null } | null;
  content?: { talent_id?: number | string | null; talent?: { id?: number | string | null } | null } | null;
} | null): number | string | undefined {
  const id =
    source?.talent?.id ??
    source?.talent_id ??
    source?.content?.talent?.id ??
    source?.content?.talent_id;
  if (id == null || String(id).trim() === "") return undefined;
  return id;
}
